"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectIsEmpty = exports.parseEditorUrl = exports.generateUniqueName = exports.deepFreeze = exports.copyPropsIfNotDefined = exports.copyPropsIfDefined = exports.copyIfDefined = exports.assignToObjectIfDefined = exports.addArrayItemAtIndex = void 0;
const valueIsNullOrUndef_1 = __importDefault(require("../typeAssertions/valueIsNullOrUndef"));
const addArrayItemAtIndex = ({ array, index, item, }) => {
    let newArray = [...array];
    if (index >= newArray.length) {
        newArray.push(item);
    }
    else {
        newArray = newArray.reduce((accumArray, itemReducer, indexReducer) => {
            if (index === indexReducer) {
                accumArray.push(item);
                accumArray.push(itemReducer);
            }
            else {
                accumArray.push(itemReducer);
            }
            return accumArray;
        }, []);
    }
    return newArray;
};
exports.addArrayItemAtIndex = addArrayItemAtIndex;
const assignToObjectIfDefined = (origin, target, propNames) => {
    propNames.forEach((propName) => {
        if (origin[propName] !== null && origin[propName] !== undefined) {
            target[propName] = origin[propName]; // eslint-disable-line
        }
    });
};
exports.assignToObjectIfDefined = assignToObjectIfDefined;
const copyIfDefined = (origin, target, propName, formatter) => {
    if (!(0, valueIsNullOrUndef_1.default)(origin[propName])) {
        if (formatter) {
            const formattedValue = formatter(origin[propName]);
            if (!(0, valueIsNullOrUndef_1.default)(formattedValue)) {
                target[propName] = formattedValue; // eslint-disable-line
            }
        }
        else {
            target[propName] = origin[propName]; // eslint-disable-line
        }
    }
};
exports.copyIfDefined = copyIfDefined;
const copyPropsIfDefined = (origin, target, props, formatter) => {
    props.forEach((propName) => (0, exports.copyIfDefined)(origin, target, propName, formatter));
    return target;
};
exports.copyPropsIfDefined = copyPropsIfDefined;
const copyPropsIfNotDefined = (original, source, propNames = []) => {
    const newStyle = Object.assign({}, original);
    propNames.forEach((propName) => {
        if (original[propName] === undefined || original[propName] === null) {
            newStyle[propName] = source[propName];
        }
    });
    return newStyle;
};
exports.copyPropsIfNotDefined = copyPropsIfNotDefined;
const deepFreeze = (value) => {
    if (value
        && value !== null
        && typeof value === 'object'
        && !Object.isFrozen(value)) {
        Object.entries(value).forEach(([, propValue]) => {
            (0, exports.deepFreeze)(propValue);
        });
        Object.freeze(value);
    }
};
exports.deepFreeze = deepFreeze;
const generateUniqueName = ({ name, names = [] }) => {
    const matchedName = names.find((nameOnList) => nameOnList === name);
    if (matchedName) {
        if (/^[^]+?[0-9]+$/.test(matchedName)) {
            const match = matchedName.match(/[0-9]+$/) || [1];
            // Has a number on it
            const nameNumber = Number(match[0]);
            const nameBody = matchedName.replace(/[0-9]+$/, '');
            return (0, exports.generateUniqueName)({
                name: `${nameBody}${nameNumber + 1}`,
                names,
            });
        }
        return (0, exports.generateUniqueName)({
            name: `${name}1`,
            names,
        });
    }
    return name;
};
exports.generateUniqueName = generateUniqueName;
const parseEditorUrl = (url) => {
    if (!/^[^]+?\/editor\/[a-zA-Z0-9\-_]+\/[a-zA-Z0-9\-_]+\/[^]*$/.test(url)) {
        throw new Error(`The URL is not valid: ${url}`);
    }
    const projectId = url
        .replace(/^[^]+?\/editor\//, '')
        .replace(/\/[a-zA-Z0-9\-_]+\/[^]*$/, '');
    const appId = url
        .replace(/^[^]+?\/editor\/[a-zA-Z0-9\-_]+\//, '')
        .replace(/\/[^]*$/, '');
    return { appId, projectId };
};
exports.parseEditorUrl = parseEditorUrl;
const objectIsEmpty = (value) => {
    if (Array.isArray(value)) {
        return value.length < 1;
    }
    const keys = Object.keys(value);
    return keys.length < 1;
};
exports.objectIsEmpty = objectIsEmpty;
